import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

// formik components
import { useFormikContext } from "formik";
import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import FormField from "components/FormField";

function IncidenceRatesForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { incidenceRateFirstYear, incidenceRateLastYear, incidenceRateScaling } = formField;

  const { countryDefaults } = useFormAnalyticsContext();
  const { values: v, setFieldValue } = useFormikContext<any>();

  const resetValues = () => {
    if (countryDefaults?.incidenceRateLastYear) {
      setFieldValue(formField.incidenceRateLastYear.name, countryDefaults.incidenceRateLastYear);
    }
  };

  useEffect(() => {
    setFieldValue(formField.incidenceRateFirstYear.name, (v?.incidenceRateLastYear ?? 0) * 0.15);
  }, [v.incidenceRateLastYear]);

  return (
    <MDBox>
      <Grid container alignItems="center" justifyContent={"space-between"}>
        <Grid item xs={10}>
          <MDTypography variant="h6">Incidence Rate (per 100,000):</MDTypography>
        </Grid>
        <Grid item xs={2}>
          <MDButton
            variant="gradient"
            color="dark"
            size="small"
            iconOnly
            onClick={() => resetValues()}
          >
            <RefreshIcon />
          </MDButton>
        </Grid>
        <Grid item xs={6}>
          <MDTypography variant="caption" lineHeight={3}>
            1900
          </MDTypography>
          <FormField
            disabled={true}
            type={incidenceRateFirstYear.type}
            label={incidenceRateFirstYear.label}
            name={incidenceRateFirstYear.name}
            value={values.incidenceRateFirstYear}
            placeholder={incidenceRateFirstYear.placeholder}
            error={errors.incidenceRateFirstYear && touched.incidenceRateFirstYear}
            precision={2}
          />
        </Grid>
        <Grid item xs={6}>
          <MDTypography variant="caption" mr={2}>
            2049
          </MDTypography>
          <FormField
            type={incidenceRateLastYear.type}
            label={incidenceRateLastYear.label}
            name={incidenceRateLastYear.name}
            value={values.incidenceRateLastYear}
            placeholder={incidenceRateLastYear.placeholder}
            error={errors.incidenceRateLastYear && touched.incidenceRateLastYear}
            precision={2}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.incidenceRateFirstYear || errors.incidenceRateLastYear}
          </MDTypography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={8}>
          <MDTypography variant="h6">Incidence rates scaling:</MDTypography>
        </Grid>
        <Grid item xs={4}>
          <FormField
            disabled={true}
            type={incidenceRateScaling.type}
            label={incidenceRateScaling.label}
            name={incidenceRateScaling.name}
            value={values.incidenceRateScaling}
            placeholder={incidenceRateScaling.placeholder}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default IncidenceRatesForm;
